import { render } from "./gaojingdetail.vue?vue&type=template&id=183427fe&scoped=true&ts=true"
import script from "./gaojingdetail.vue?vue&type=script&lang=ts"
export * from "./gaojingdetail.vue?vue&type=script&lang=ts"

import "./gaojingdetail.vue?vue&type=style&index=0&id=183427fe&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-183427fe"]])

export default __exports__